import React from 'react';

function PersonalisedHeader({name, img, link}) {
    return (
        <div className={'rowFlex'}>
            <img src={img} className={'profilePic'}/>
            <h3 style={{margin:'0 10px'}}>Welcome <a href={link} target={'_blank'} style={{textDecoration:'none'}}>{name}</a></h3>
        </div>
    )
}
export default PersonalisedHeader;